const WEEKDAYS = '日一二三四五六'
// 台灣時間 UTC+8（無日光節約）
const TAIPEI_OFFSET_MS = 8 * 60 * 60 * 1000

const pad = (n) => String(n).padStart(2, '0')

function toTaipeiParts(value) {
  if (value === null || value === undefined || value === '') {
    return null
  }
  const time = new Date(value).getTime()
  if (Number.isNaN(time)) {
    return null
  }
  const d = new Date(time + TAIPEI_OFFSET_MS)
  return {
    year: d.getUTCFullYear() - 1911,
    month: pad(d.getUTCMonth() + 1),
    day: pad(d.getUTCDate()),
    weekday: WEEKDAYS[d.getUTCDay()],
    time: `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`,
  }
}

/**
 * 民國日期，例：115/10/21(三)
 */
export function toRocDate(value) {
  const p = toTaipeiParts(value)
  return p ? `${p.year}/${p.month}/${p.day}(${p.weekday})` : ''
}

/**
 * 民國日期時間，例：115/10/21(三)00:00:00
 */
export function toRocDateTime(value) {
  const p = toTaipeiParts(value)
  return p ? `${toRocDate(value)}${p.time}` : ''
}

function toRange(start, end, formatter) {
  const a = formatter(start)
  const b = formatter(end)
  return a && b ? `${a}~${b}` : ''
}

/**
 * 由 /academicSetting/current 回應組出前台日程文字
 */
export function buildTimeInfo(data) {
  const d = data || {}
  return {
    registrationPeriod: toRange(
      d.startTime,
      d.applicationDeadline,
      toRocDateTime,
    ),
    firstPayDeadline: toRocDateTime(d.firstPayDeadline),
    firstResultDate: toRocDate(d.firstResultTime),
    interviewPeriod: toRange(d.interviewStart, d.interviewEnd, toRocDate),
    secondResultDate: toRocDate(d.secondResultTime),
  }
}

export default {
  toRocDate,
  toRocDateTime,
  buildTimeInfo,
}
